var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('referral-details',{attrs:{"referralId":_vm.referralId,"referralType":_vm.referralType,"isReadOnly":true,"allowPageClose":false}})}
var staticRenderFns = []

export { render, staticRenderFns }